import Modal from "modal/Modal";
import $ from "jquery";

class AlertModal extends Modal {
    constructor(message, title = undefined, settings = {}) {
        super($.extend({}, AlertModal.DEFAULT_SETTINGS, settings));
        if ('undefined' === typeof title) title = '';
        this.setContent(
            eotwJSXFactory('div', null, [
                eotwJSXFactory('h2', null, [title]),
                eotwJSXFactory('span', {class: "admin-modal--confirm__text"}, [message]),
                eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal"}, ["Ok"]).on("click", () => this.destroy())
                ])
            ])
        );
    }

    static alert(message, title = undefined, settings = {}) {
        let modal = new AlertModal(message, title, settings);
        modal.show();
        return modal;
    }
}

AlertModal.DEFAULT_SETTINGS = {
    "class": "modal--alert",
    destroyOnClose: true
};

export default AlertModal;
